if (!customElements.get("predictive-search")) {
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();

      this.input = this.querySelector('input[type="search"]');
      this.resultsContainer = this.querySelector(".js-results-container");
      this.btnSubmit = this.querySelector(".js-btn-submit");
      this.btnClearText = this.querySelector(".js-btn-clear-text");
      this.errorMessageContainer = this.querySelector(".js-message-error");
      this.errorMessageText =
        this.errorMessageContainer.querySelector("[data-text]");
      this.timeout = null;
      this.isOpen = false;
      this.drawer = this.closest(".js-drawer");
      this.form = this.querySelector("form");

      var searchDrawerContent = document.querySelector(
        ".drawer__content--search"
      );
      var searchSuggestions = document.querySelector(
        ".search-drawer__suggestions"
      );

      this.input.addEventListener("input", (e) => {
        clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          const searchTerm = this.input.value.trim();

          if (searchTerm.length <= 0) {
            this.close();
            if (searchSuggestions) {
              searchSuggestions.style.display = "flex";
            }
            return;
          }

          this.isOpen = true;
          this.getSearchResults(searchTerm);
          if (searchSuggestions) {
            searchSuggestions.style.display = "none";
          }
        }, 300);
      });

      this.input.addEventListener("keydown", (e) => {
        const isEscape = e.key === "Escape";
        const isEnter = e.key === "Enter";

        if (isEnter) {
          const searchTerm = this.input.value.trim();
          if (searchTerm.length <= 0) {
            e.preventDefault();
            return;
          }
        }

        if (!isEscape) {
          return;
        }

        if (!this.input.value) {
          if (this.drawer) {
            this.drawer.parentElement.parentElement.toggleDrawer();
          }

          return;
        }

        this.close();
      });

      this.btnClearText.addEventListener("click", (e) => {
        this.close();
        if (searchSuggestions) {
          searchSuggestions.style.display = "flex";
        }
      });

      this.form.addEventListener("submit", (e) => {
        const searchTerm = this.input.value.trim();
        if (searchTerm.length === 0) {
          e.preventDefault();
          return false;
        }
      });

      window.addEventListener('DOMContentLoaded', () => {
        const links = document.querySelectorAll('.search-drawer__suggestions a');
        this.popularSearchesClick(links)
      })
    }

    async getSearchResults(searchTerm) {
      if (!searchTerm || searchTerm === "" || searchTerm.trim().length === 0) {
        this.close();
        return;
      }

      try {
        this.showLoading();

        const response = await fetch(
          `${Shopify.routes.root}search/suggest?q=${searchTerm}&resources[type]=product,collection&resources[limit]=8&section_id=predictive-search`
        );

        if (!this.isOpen) {
          return;
        }

        if (!response.ok) {
          const error = new Error(response.status);
          throw error;
        }

        const text = await response.text();
        
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;

        this.resultsContainer.innerHTML = resultsMarkup;
        this.open();

        const messageParagraph = document.querySelector(
          ".predictive-search__message p"
        );
        if (messageParagraph) {
          const searchTermSpan = messageParagraph.querySelector(
            ".predictive-search__search-term"
          );
          let textContent = messageParagraph.childNodes[0]
            ? messageParagraph.childNodes[0].textContent.trim()
            : "";
          const lastSpaceIndex = textContent.lastIndexOf(" ");
          if (lastSpaceIndex !== -1) {
            textContent = textContent.substring(0, lastSpaceIndex).trim();
          }
          messageParagraph.textContent = textContent + " ";
          if (searchTermSpan) {
            messageParagraph.appendChild(searchTermSpan);
          }
        }

        // new added product cards - quick cart triggers - set event listeners
        document.querySelector("quick-cart-drawer")?.initTriggers();

        const productWrap = document.querySelector('.predictive-search__grid')
        
        if (!productWrap) {
          const data = {
            search_term: searchTerm
          }

          sendGTMEventData("search_no_results", data)
        }

        const links = document.querySelectorAll('.predictive-search__col a');
        this.popularSearchesClick(links)
        this.searchResultsClick()
      } catch (error) {
        this.errorMessageText.textContent = error.message;
        this.errorMessageContainer.classList.remove("hidden");
      }
    }

    popularSearchesClick(links) {
      if (!links.length) return
      links.forEach(link => {
        link.addEventListener('click', () => {
          const text = link.querySelector('.button__text')?.textContent.trim() || ''

          const data = {
            suggested_search_term: text
          }

          sendGTMEventData("search_suggested_term", data)
        })
      })
    }

    searchResultsClick() {
      const links = document.querySelectorAll('.predictive-search__grid a')
      if (!links.length) return
      links.forEach(link => {
        link.addEventListener('click', () => {
          const text = link.querySelector('img').alt.trim()

          const data = {
            search_listing_item_name: text,
            search_results_select: 'predictive_search'
          }

          sendGTMEventData("search_results_select", data)
        })
      })
    }

    open() {
      this.classList.add("is-open");
      this.resultsContainer.classList.remove("hidden");
      this.resultsContainer.style.setProperty("margin-block", "0");

      const searchSuggestions = document.querySelector(
        ".search-drawer__suggestions"
      );
      if (searchSuggestions) {
        searchSuggestions.classList.add("search-drawer-content-spacing");
      }

      this.errorMessageContainer.classList.add("hidden");
      this.btnSubmit.setAttribute("tabindex", "-1");
      this.btnClearText.removeAttribute("disabled");
    }

    close() {
      this.isOpen = false;
      this.classList.remove("is-open");
      this.resultsContainer.classList.add("hidden");
      this.errorMessageContainer.classList.add("hidden");
      this.input.value = "";
      this.input.focus();
      this.btnSubmit.removeAttribute("tabindex");
      this.btnClearText.setAttribute("disabled", true);
    }

    showLoading() {
      const loadingElement = this.querySelector(".js-search-loading");
      if (loadingElement) {
        loadingElement.classList.remove("hidden");
      }
      this.resultsContainer.classList.remove("hidden");
    }
  }

  customElements.define("predictive-search", PredictiveSearch);
}
